import React, { useContext } from "react";
import cx from "classnames";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "@common/components";
import { ContextEDH } from "@context/ContextEDH";
import { useProgrammingStructuresPermissions } from "@modules/programming-structures/hooks/useProgrammingStructuresPermissions";
import Layout from "@common/layout";
import styles from "./programmingStructuresLayout.module.scss";

interface ProgrammingStructuresLayoutProps {
  children?: React.ReactNode;
  className?: string;
}

const ProgrammingStructuresLayout = ({ children, className }: ProgrammingStructuresLayoutProps) => {
  const { t } = useTranslation();
  const { state } = useContext(ContextEDH);
  const { permissions } = useProgrammingStructuresPermissions();

  if (!!state?.base?.base?.user?.id && !permissions?.read) {
    return <Redirect to="/" />;
  }

  return (
    <Layout contextSearch>
      <Header title={t("programming-structures.title")} />
      <div className={cx(styles.programmingStructuresLayout, className)}>{children}</div>
    </Layout>
  );
};

export default ProgrammingStructuresLayout;
